export const SCREENS = {
  PRIVATE: {
    BROKER: {
      INDEX: { path: "/broker", breadcrumb: [] },
      DASHBOARD: { path: "/broker/dashboard", breadcrumb: [] },
      CONTRACTS: {
        LIST: { path: "/broker/contracts", breadcrumb: [] },
        CREATE: { path: "/broker/contracts/create", breadcrumb: [] },
        DETAIL: { path: "/broker/contracts/detail", breadcrumb: [] },
        DELETE: { path: "/broker/contracts/delete", breadcrumb: [] },
      },
      CLIENTS: {
        LIST: { path: "/broker/clients", breadcrumb: [] },
        CREATE: { path: "/broker/clients/create", breadcrumb: [] },
        DETAIL: { path: "/broker/clients/detail", breadcrumb: [] },
      },
      QUALIFICATIONS: {
        LIST: { path: "/broker/qualifications", breadcrumb: [] },
        CREATE: { path: "/broker/qualifications/create", breadcrumb: [] },
        SHOW: { path: "/broker/qualifications/show", breadcrumb: [] },
      },
      NOTES: {
        LIST: { path: "/broker/notes", breadcrumb: [] },
        CREATE: { path: "/broker/notes/create", breadcrumb: [] },
        DELETE: { path: "/broker/notes/delete", breadcrumb: [] },
      },
      ORGANIZATIONS: {
        LIST: { path: "/broker/organizations", breadcrumb: [] },
        CREATE: { path: "/broker/organizations/create", breadcrumb: [] },
        DETAIL: { path: "/broker/organizations/detail", breadcrumb: [] },
        DELETE: { path: "/broker/organizations/delete", breadcrumb: [] },
      },
      PROJECTS: {
        LIST: { path: "/broker/projects", breadcrumb: [] },
        CREATE: {
          NORMAL: { path: "/broker/projects/create/normal", breadcrumb: [] },
          FAST: { path: "/broker/projects/create/fast", breadcrumb: [] },
        },
        DETAIL: {
          path: "/broker/projects/detail",
          breadcrumb: [
            { label: "PRIVATE.BROKER.DASHBOARD", to: "" },
            { label: "PRIVATE.BROKER.PROJECT.CREATE", to: "" },
            { label: "PRIVATE.BROKER.PROJECT.DETAIL", to: "" },
          ],
        },
        DELETE: { path: "/broker/projects/delete", breadcrumb: [] },
        TRACERS: {
          IDENTIFY: {
            path: "/broker/projects/tracers/identify",
            breadcrumb: [],
          },
        },
      },
      USERS: {
        LIST: { path: "/broker/users", breadcrumb: [] },
        CREATE: { path: "/broker/users/create", breadcrumb: [] },
        DETAIL: { path: "/broker/users/detail", breadcrumb: [] },
        DELETE: { path: "/broker/users/delete", breadcrumb: [] },
      },
      REMINDERS: {
        LIST: { path: "/broker/reminders", breadcrumb: [] },
        CREATE: { path: "/broker/reminders/create", breadcrumb: [] },
      },
      SUBSCRIPTIONS: {
        DETAIL: { path: "/broker/subscriptions/detail", breadcrumb: [] },
        SEND_LINK: { path: "/broker/subscriptions/sendLink", breadcrumb: [] },
      },
      COLLABORATORS: {
        LIST: { path: "/broker/collaborators", breadcrumb: [] },
        CREATE: { path: "/broker/collaborators/create", breadcrumb: [] },
        DETAIL: { path: "/broker/collaborators/detail", breadcrumb: [] },
        DELETE: { path: "/broker/collaborators/delete", breadcrumb: [] },
      },
      COMMISSION_STATEMENTS: {
        LIST: { path: "/broker/commissions-statements", breadcrumb: [] },
      },
      NOTIFICATIONS: {
        LIST: { path: "/broker/notifications", breadcrumb: [] },
      },
    },
    GUEST: {
      PROJECTS: {
        DETAIL: {
          path: "/guest/projects/detail",
          breadcrumb: [],
        },
      },
    },
    ADMIN: {
      INDEX: { path: "/admin", breadcrumb: [] },
      DASHBOARD: { path: "/admin/dashboard", breadcrumb: [] },
      PROCESSES: {
        LIST: { path: "/admin/processes", breadcrumb: [] },
        CREATE: { path: "/admin/processes/create", breadcrumb: [] },
        DETAIL: { path: "/admin/processes/detail", breadcrumb: [] },
        DELETE: { path: "/admin/processes/delete", breadcrumb: [] },
        PREVIEW: { path: "/admin/processes/preview", breadcrumb: [] },
      },
      FLOWS: {
        LIST: { path: "/admin/flows", breadcrumb: [] },
        CREATE: { path: "/admin/flows/create", breadcrumb: [] },
        DETAIL: { path: "/admin/flows/detail", breadcrumb: [] },
        DELETE: { path: "/admin/flows/delete", breadcrumb: [] },
      },
      TRACERS: {
        LIST: { path: "/admin/tracers", breadcrumb: [] },
        CREATE: { path: "/admin/tracers/create", breadcrumb: [] },
        DETAIL: { path: "/admin/tracers/detail", breadcrumb: [] },
        DELETE: { path: "/admin/tracers/delete", breadcrumb: [] },
      },
      SOURCES: {
        LIST: { path: "/admin/sources", breadcrumb: [] },
        CREATE: { path: "/admin/sources/create", breadcrumb: [] },
        DETAIL: { path: "/admin/sources/detail", breadcrumb: [] },
        DELETE: { path: "/admin/sources/delete", breadcrumb: [] },
      },
      USERS: {
        LIST: { path: "/admin/users", breadcrumb: [] },
        CREATE: { path: "/admin/users/create", breadcrumb: [] },
        DETAIL: { path: "/admin/users/detail", breadcrumb: [] },
        DELETE: { path: "/admin/users/delete", breadcrumb: [] },
        DEACTIVATE: { path: "/admin/users/deactivate", breadcrumb: [] },
      },
      BROKERS: {
        LIST: { path: "/admin/brokers", breadcrumb: [] },
        CREATE: { path: "/admin/brokers/create", breadcrumb: [] },
        DETAIL: { path: "/admin/brokers/detail", breadcrumb: [] },
        DELETE: { path: "/admin/brokers/delete", breadcrumb: [] },
      },
      ORGANIZATIONS: {
        LIST: { path: "/admin/organizations", breadcrumb: [] },
        CREATE: { path: "/admin/organizations/create", breadcrumb: [] },
        DETAIL: { path: "/admin/organizations/detail", breadcrumb: [] },
        DELETE: { path: "/admin/organizations/delete", breadcrumb: [] },
      },
      INSURANCE_PLANS: {
        LIST: { path: "/admin/insurance-plans", breadcrumb: [] },
        CREATE: { path: "/admin/insurance-plans/create", breadcrumb: [] },
        DETAIL: { path: "/admin/insurance-plans/detail", breadcrumb: [] },
        DELETE: { path: "/admin/insurance-plans/delete", breadcrumb: [] },
        EDIT: { path: "/admin/insurance-plans/edit", breadcrumb: [] },
      },
      OFFERS: {
        LIST: { path: "/admin/offers", breadcrumb: [] },
        DELETE: { path: "/admin/offers/delete", breadcrumb: [] },
      },
      COVERAGES: {
        LIST: { path: "/admin/coverages", breadcrumb: [] },
        CREATE: { path: "/admin/coverages/create", breadcrumb: [] },
        DETAIL: { path: "/admin/coverages/detail", breadcrumb: [] },
        DELETE: { path: "/admin/coverages/delete", breadcrumb: [] },
      },
      COVERAGE_BENEFITS: {
        LIST: { path: "/admin/coverage-benefits", breadcrumb: [] },
        CREATE: { path: "/admin/coverage-benefits/create", breadcrumb: [] },
        DETAIL: { path: "/admin/coverage-benefits/detail", breadcrumb: [] },
        DELETE: { path: "/admin/coverage-benefits/delete", breadcrumb: [] },
      },
      QUALIFIERS: {
        LIST: { path: "/admin/qualifiers", breadcrumb: [] },
        CREATE: { path: "/admin/qualifiers/create", breadcrumb: [] },
        DETAIL: { path: "/admin/qualifiers/detail", breadcrumb: [] },
        DELETE: { path: "/admin/qualifiers/delete", breadcrumb: [] },
      },
      QUALIFICATIONS: {
        LIST: { path: "/admin/qualifications", breadcrumb: [] },
        CREATE: { path: "/admin/qualifications/create", breadcrumb: [] },
        SHOW: { path: "/admin/qualifications/show", breadcrumb: [] },
      },
      WEBHOOKS: {
        LIST: { path: "/admin/webhooks", breadcrumb: [] },
      },
      COVERAGE_CATEGORIES: {
        LIST: { path: "/admin/coverage-categories", breadcrumb: [] },
        CREATE: { path: "/admin/coverage-categories/create", breadcrumb: [] },
        DETAIL: { path: "/admin/coverage-categories/detail", breadcrumb: [] },
        DELETE: { path: "/admin/coverage-categories/delete", breadcrumb: [] },
        WEIGHT: { path: "/admin/coverage-categories/weight", breadcrumb: [] },
      },
      UI: {
        LIST: { path: "/admin/ui", breadcrumb: [] },
        LMF: { path: "/admin/ui/lmf", breadcrumb: [] },
      },
      WORKFLOWS: {
        LIST: { path: "/admin/workflows", breadcrumb: [] },
        CREATE: { path: "/admin/workflows/create", breadcrumb: [] },
        DETAIL: { path: "/admin/workflows/detail", breadcrumb: [] },
        DELETE: { path: "/admin/workflows/delete", breadcrumb: [] },
      },
      PRICERS: {
        LIST: { path: "/admin/prices", breadcrumb: [] },
        CREATE: { path: "/admin/prices/create", breadcrumb: [] },
        DETAIL: { path: "/admin/prices/detail", breadcrumb: [] },
        DELETE: { path: "/admin/prices/delete", breadcrumb: [] },
      },
      COMMISSION_STATEMENTS: {
        LIST: { path: "/admin/commissions-statements", breadcrumb: [] },
        CREATE: {
          path: "/admin/commissions-statements/create",
          breadcrumb: [],
        },
        DELETE: {
          path: "/admin/commissions-statements/delete",
          breadcrumb: [],
        },
      },
      COMMISSIONS: {
        LIST: { path: "/admin/commissions", breadcrumb: [] },
        CREATE: { path: "/admin/commissions/create", breadcrumb: [] },
        DETAIL: { path: "/admin/commissions/detail", breadcrumb: [] },
        DELETE: { path: "/admin/commissions/delete", breadcrumb: [] },
      },
      TEMPLATES: {
        LIST: { path: "/admin/templates", breadcrumb: [] },
        CREATE: { path: "/admin/templates/create", breadcrumb: [] },
        DETAIL: { path: "/admin/templates/detail", breadcrumb: [] },
        DELETE: { path: "/admin/templates/delete", breadcrumb: [] },
      },
      BRANDS: {
        LIST: { path: "/admin/brands", breadcrumb: [] },
        CREATE: { path: "/admin/brands/create", breadcrumb: [] },
        DETAIL: { path: "/admin/brands/detail", breadcrumb: [] },
        DELETE: { path: "/admin/brands/delete", breadcrumb: [] },
      },
      STORES: {
        LIST: { path: "/admin/stores", breadcrumb: [] },
        CREATE: { path: "/admin/stores/create", breadcrumb: [] },
        DETAIL: { path: "/admin/stores/detail", breadcrumb: [] },
        DELETE: { path: "/admin/stores/delete", breadcrumb: [] },
      },
    },
    EXCHANGE: { path: "/exchange", breadcrumb: [] },
  },
  AUTH: {
    REDIRECT: { path: "/auth/redirect", breadcrumb: [] },
    LOGOUT: { path: "/auth/logout", breadcrumb: [] },
    SIGN_IN: { path: "/", breadcrumb: [] },
    SIGN_IN_TWO_FACTOR: { path: "auth/two-factor", breadcrumb: [] },
    VERIFICATION: { path: "/auth/verification", breadcrumb: [] },
    RESET_PASSWORD: { path: "/auth/password/passcode", breadcrumb: [] },
    FORGOT_PASSWORD: { path: "/auth/password/forgot", breadcrumb: [] },
    NOT_ACTIVE: { path: "/auth/not-active", breadcrumb: [] },
  },
  PUBLIC: {
    INDEX: { path: "/", breadcrumb: [] },
    CONTACTS: {
      INDEX: { path: "/contacts", breadcrumb: [] },
    },
    NOTES: {
      CREATE: { path: "/notes/create", breadcrumb: [] },
    },
    QUOTES: {
      DETAIL: { path: "/quotes", breadcrumb: [] },
    },
    PROCESSES: {
      IFRAME: { path: "/public/process", breadcrumb: [] },
      DETAIL: { path: "/public/process", breadcrumb: [] },
      CREATE: { path: "/public/process/create", breadcrumb: [] },
      INIT: { path: "/public/process/init", breadcrumb: [] },
    },
  },
};

export const CONTRACT_TYPES = {
  PRIVACY: "PRIVACY",
  DISCLOSURE: "DISCLOSURE",
  HEALTHINSURANCE: "HEALTHINSURANCE",
  SUPPLY: "SUPPLY",
  CONSENT: "CONSENT",
};

export const CONTRACT_SUBTYPES = ["DISCLOSURE_CA", "DISCLOSURE_US"];

export const CONTRACT_CONTENT_DERIVATIVE = [
  "REGISTRATION",
  "RETRIEVAL",
  "STATEMENT",
  "SHAREABLE",
];

export const CONTRACT_EXPIRATION_TYPES = ["BREACH"];

export const CONTRACT_SCOPE = ["POLICY"];

export const ORGANIZATION_TYPE = [
  "PROV",
  "DEPT",
  "TEAM",
  "GOVT",
  "INS",
  "PAY",
  "EDU",
  "RELI",
  "CRS",
  "CG",
  "BUS",
  "BROKER",
  "OTHER",
];

export const KEYS = {
  ACCESS_TOKEN: "accessToken",
  USER: "user",
  LANGUAGE: "language",
};

export const USER_TYPES = {
  ADMIN: {
    type: "admin",
    index: SCREENS.PRIVATE.ADMIN.DASHBOARD.path,
  },
  INSURANCE_ADMIN: {
    type: "admin.insurance",
    index: SCREENS.PRIVATE.ADMIN.INSURANCE_PLANS.LIST.path,
  },
  INSURANCE_EMPLOYEE: {
    type: "employee.insurance",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  INSURANCE_REPRESENTATIVE: {
    type: "representative.insurance",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  BROKER_DASHBOARD: {
    type: "broker.dashboard",
    index: SCREENS.PRIVATE.BROKER.DASHBOARD.path,
  },
  BROKER_ADMIN: {
    type: "admin.broker",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  BROKER_EMPLOYEE: {
    type: "employee.broker",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  BROKER_REPRESENTATIVE: {
    type: "representative.broker",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  INTERNAL_SUPERVISOR: {
    type: "supervisor.internal",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  INTERNAL_ADVISOR: {
    type: "advisor.internal",
    index: SCREENS.PRIVATE.BROKER.PROJECTS.LIST.path,
  },
  INSURANCE_GUEST: {
    type: "guest.insurance",
    index: SCREENS.AUTH.LOGOUT.path,
  },
};

export const MODULES = {
  DASHBOARD: "DASHBOARD",
  SOURCE: "SOURCE",
  TRACER: "TRACER",
  FLOW: "FLOW",
  USER: "USER",
  PROCESS: "PROCESS",
  PROCESS_STATUS: "PROCESS_STATUS",
  INSURANCE_PLAN: "INSURANCE_PLAN",
  COVERAGE: "COVERAGE",
  COVERAGE_BENEFIT: "COVERAGE_BENEFIT",
  SUBSCRIPTION: "SUBSCRIPTION",
  ORGANIZATION: "ORGANIZATION",
  QUALIFICATION: "QUALIFICATION",
  QUALIFIER: "QUALIFIER",
  WEBHOOK: "WEBHOOK",
  COLLABORATORS: "COLLABORATORS",
  PROJECT: "PROJECT",
  GENERAL_COST: "GENERAL_COST",
  CONTRACT: "CONTRACT",
  CONTACT: "CONTACT",
  REMINDER: "REMINDER",
  NOTE: "NOTE",
  BROKER: "BROKER",
  WORKFLOW: "WORKFLOW",
  PRICER: "PRICER",
  COMMISSION_STATEMENT: "COMMISSION_STATEMENT",
  COMMISSION: "COMMISSION",
  COVERAGE_CATEGORY: "COVERAGE_CATEGORY",
  OFFER: "OFFER",
  TEMPLATE: "TEMPLATE",
  MODEL: "MODEL",
  BRAND: "BRAND",
  STORE: "STORE",
  NOTIFICATION: "NOTIFICATION",
};

export const SUBMODULES = {
  ADMIN_LIST: "ADMIN_LIST",
  ADMIN_CREATE: "ADMIN_CREATE",
  ADMIN_DETAIL: "ADMIN_DETAIL",
  ADMIN_EDIT: "ADMIN_EDIT",
  ADMIN_DELETE: "ADMIN_DELETE",
  ADMIN_SHOW: "ADMIN_SHOW",
  BROKER_LIST: "BROKER_LIST",
  BROKER_CREATE: "BROKER_CREATE",
  BROKER_DETAIL: "BROKER_DETAIL",
  BROKER_DELETE: "BROKER_DELETE",
  BROKER_IDENTIFY: "BROKER_IDENTIFY",
  BROKER_SHOW: "BROKER_SHOW",
};

export const ACTIONS = {
  DASHBOARD: "dashboard",
  SOURCES: "sources",
  DELETE_SOURCE: "deleteSource",
  ADD_SOURCE: "addSource",
  SOURCE: "source",
  UPDATE_SOURCE: "updateSource",
  TRACERS: "tracers",
  DELETE_TRACER: "deleteTracer",
  ADD_TRACER: "addTracer",
  TRACER: "tracer",
  UPDATE_TRACER: "updateTracer",
  FLOWS: "flows",
  DELETE_FLOW: "deleteFlow",
  ADD_FLOW: "addFlow",
  FLOW: "flow",
  UPDATE_FLOW: "updateFlow",
  USERS: "users",
  DELETE_USER: "deleteUser",
  ADD_USER: "addUser",
  USER: "user",
  UPDATE_USER: "updateUser",
  PROCESSES: "processes",
  DELETE_PROCESS: "deleteProcess",
  ADD_PROCESS: "addProcess",
  PROCESS: "process",
  UPDATE_PROCESS: "updateProcess",
  DELETE_COVERAGE: "deleteCoverage",
  ADD_COVERAGE: "addCoverage",
  COVERAGES: "coverages",
  COVERAGE: "coverage",
  UPDATE_COVERAGE: "updateCoverage",
  COVERAGE_BENEFITS: "coverageBenefits",
  DELETE_COVERAGE_BENEFIT: "deleteCoverageBenefit",
  ADD_COVERAGE_BENEFIT: "addCoverageBenefit",
  COVERAGE_BENEFIT: "coverageBenefit",
  UPDATE_COVERAGE_BENEFIT: "updateCoverageBenefit",
  SUBSCRIPTION: "subscription",
  UPDATE_SUBSCRIPTION: "updateSubscription",
  SEND_SUBSCRIPTION_ATTACHMENTS: "sendSubscriptionAttachments",
  DOWNLOAD_SUBSCRIPTION_ATTACHMENTS: "downloadSubscriptionAttachments",
  EXPORT_SUBSCRIPTIONS: "exportSubscriptions",
  QUALIFICATIONS: "qualifications",
  DELETE_QUALIFICATION: "deleteQualification",
  ADD_QUALIFICATION: "addQualification",
  QUALIFICATION: "qualification",
  UPDATE_QUALIFICATION: "updateQualification",
  ORGANIZATIONS: "organizations",
  DELETE_ORGANIZATION: "deleteOrganization",
  ADD_ORGANIZATION: "addOrganization",
  ORGANIZATION: "organization",
  UPDATE_ORGANIZATION: "updateOrganization",
  BROKERS: "brokers",
  DELETE_BROKER: "deleteBroker",
  ADD_BROKER: "addBroker",
  BROKER: "broker",
  UPDATE_BROKER: "updateBroker",
  NOTES: "notes",
  ADD_NOTE: "addNote",
  QUALIFIERS: "qualifiers",
  DELETE_QUALIFIER: "deleteQualifier",
  ADD_QUALIFIER: "addQualifier",
  QUALIFIER: "qualifier",
  UPDATE_QUALIFIER: "updateQualifier",
  WEBHOOKS: "webhooks",
  DUPLICATE_PROJECT: "duplicateProject",
  DELETE_PROJECT: "deleteProject",
  ADD_PROJECT: "addProject",
  PROJECT: "project",
  PROJECTS: "projects",
  UPDATE_PROJECT: "updateProject",
  ASSIGN_PROJECT: "assignProject",
  GENERAL_COSTS: "generalCosts",
  CONTRACTS: "contracts",
  DELETE_CONTRACT: "deleteContract",
  ADD_CONTRACT: "addContract",
  CONTRACT: "contract",
  UPDATE_CONTRACT: "updateContract",
  CONTACTS: "contacts",
  DELETE_CONTACT: "deleteContact",
  ADD_CONTACT: "addContact",
  CONTACT: "contact",
  UPDATE_CONTACT: "updateContact",
  REMINDERS: "reminders",
  ADD_REMINDER: "addReminder",
  INSURANCE_PLANS: "insurancePlans",
  INSURANCE_PLAN: "insurancePlan",
  ADD_INSURANCE_PLAN: "addInsurancePlan",
  UPDATE_INSURANCE_PLAN: "updateInsurancePlan",
  DELETE_INSURANCE_PLAN: "deleteInsurancePlan",
  WORKFLOW: "workflow",
  WORKFLOWS: "workflows",
  ADD_WORKFLOW: "addWorkflow",
  UPDATE_WORKFLOW: "updateWorkflow",
  DELETE_WORKFLOW: "deleteWorkflow",
  PRICER: "pricer",
  PRICERS: "pricers",
  ADD_PRICER: "addPricer",
  UPDATE_PRICER: "updatePricer",
  DELETE_PRICER: "deletePricer",
  COMMISSION_STATEMENT: "commissionStatement",
  COMMISSION_STATEMENTS: "commissionStatements",
  ADD_COMMISSION_STATEMENT: "addCommissionStatement",
  UPDATE_COMMISSION_STATEMENT: "updateCommissionStatement",
  DELETE_COMMISSION_STATEMENT: "deleteCommissionStatement",
  DOWNLOAD_SINGLE_DOCUMENT: "downloadSingleDocument",
  COMMISSION: "commission",
  COMMISSIONS: "commissions",
  ADD_COMMISSION: "addCommission",
  UPDATE_COMMISSION: "updateCommission",
  DELETE_COMMISSION: "deleteCommission",
  COVERAGE_CATEGORY: "coverageCAtegory",
  COVERAGE_CATEGORIES: "coverageCAtegories",
  ADD_COVERAGE_CATEGORY: "addCoverageCategory",
  UPDATE_COVERAGE_CATEGORY: "updateCoverageCategory",
  DELETE_COVERAGE_CATEGORY: "deleteCoverageCategory",
  ADD_OFFER: "addOffer",
  UPDATE_OFFER: "updateOffer",
  DELETE_OFFER: "deleteOffer",
  BRAND: "brand",
  BRANDS: "brands",
  ADD_BRAND: "addBrand",
  UPDATE_BRAND: "updateBrand",
  DELETE_BRAND: "deleteBrand",
  MODEL: "model",
  MODELS: "models",
  ADD_MODEL: "addModel",
  UPDATE_MODEL: "updateModel",
  DELETE_MODEL: "deleteModel",
  STORE: "store",
  STORES: "stores",
  ADD_STORE: "addStore",
  UPDATE_STORE: "updateStore",
  DELETE_STORE: "deleteStore",
};

export const PROCESS_TYPES = {
  B2B: "B2B",
  B2C: "B2C",
};

export const TEMPLATE_TYPES = {
  DEFAULT: "DEFAULT",
  B2B_RADIANCE_COSA: "B2B_RADIANCE_COSA",
  B2B_SMART_PHONE: "B2B_SMART_PHONE",
  RADIANCE: "RADIANCE",
  RADIANCE_COSA: "RADIANCE_COSA",
  B2B_SOLYON: "B2B_SOLYON",
  B2C_SOLYON: "B2C_SOLYON",
  B2C_LMF: "B2C_LMF",
  B2B_LMF: "B2B_LMF",
  B2C_AMELLIS: "B2C_AMELLIS",
  B2B_AMELLIS: "B2B_AMELLIS",
};

export const TEMPLATES = {
  [PROCESS_TYPES.B2B]: {
    THEMES: {
      [TEMPLATE_TYPES.DEFAULT]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        PRODUCT_NO_LEVELS: "PRODUCT.NO.LEVELS",
        FAST: "FAST",
      },
      [TEMPLATE_TYPES.B2B_RADIANCE_COSA]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        PRODUCT_NO_LEVELS: "PRODUCT.NO.LEVELS",
        FAST: "FAST",
      },
      [TEMPLATE_TYPES.B2B_SMART_PHONE]: {
        ELIGIBILITY_CHECK: "ELIGIBILITY_CHECK",
        TERMINAL_INFO: "TERMINAL_INFO",
        CONTACT: "CONTACT",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
      },
      [TEMPLATE_TYPES.B2B_SOLYON]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        UPSELLS: "UPSELLS",
      },
      [TEMPLATE_TYPES.B2B_LMF]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        UPSELLS: "UPSELLS",
      },
      [TEMPLATE_TYPES.B2B_AMELLIS]: {
        CONTACT: "CONTACT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        SELECT_PRODUCTS: "SELECT_PRODUCTS",
        COMPARISON: "COMPARISON",
        QUOTE: "QUOTE",
        SUBSCRIPTION: "SUBSCRIPTION",
        CONTRACT: "CONTRACT",
        UPSELLS: "UPSELLS",
      },
    },
  },
  [PROCESS_TYPES.B2C]: {
    THEMES: {
      [TEMPLATE_TYPES.DEFAULT]: {
        GENDER: "GENDER",
        BENEFICIARIES: "BENEFICIARIES",
        CHILDREN_NUMBER: "CHILDREN.NUMBER",
        NEEDS: "NEEDS",
        EFFECTIVE_DATE: "EFFECTIVE.DATE",
        ADHERENT_INFO: "ADHERENT.INFO",
        ADHERENT_SOCIAL_REGIME: "ADHERENT.SOCIAL_REGIME",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        SPOUSE_BIRTHDATE: "SPOUSE.BIRTHDATE",
        SPOUSE_SOCIAL_REGIME: "SPOUSE.SOCIAL_REGIME",
        CHILDREN_BIRTHDATES: "CHILDREN.BIRTHDATES",
        PRODUCTS: "PRODUCTS",
        B2C_EDIT_SUBSCRIPTION: "B2C_EDIT_SUBSCRIPTION",
        B2C_SUBSCRIPTION_CONTRACT: "B2C_SUBSCRIPTION_CONTRACT",
        B2C_SUBSCRIPTION_DONE: "B2C_SUBSCRIPTION_DONE",
        E_SIGN: "E_SIGN",
        B2C_SUBSCRIPTION: "B2C_SUBSCRIPTION",
      },
      [TEMPLATE_TYPES.RADIANCE]: {
        ADHERENT_INFO: "ADHERENT.INFO",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        PRODUCTS: "PRODUCTS",
        NO_SUBSCRIPTION: "NO_SUBSCRIPTION",
        CONTACT_US: "CONTACT_US",
        B2C_EDIT_SUBSCRIPTION: "B2C_EDIT_SUBSCRIPTION",
        B2C_SUBSCRIPTION_CONTRACT: "B2C_SUBSCRIPTION_CONTRACT",
        B2C_SUBSCRIPTION_DONE: "B2C_SUBSCRIPTION_DONE",
        B2C_SUBSCRIPTION: "B2C_SUBSCRIPTION",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        E_SIGN: "E_SIGN",
        PAYMENT: "PAYMENT",
      },
      [TEMPLATE_TYPES.RADIANCE_COSA]: {
        ADHERENT_INFO: "ADHERENT.INFO",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        PRODUCTS: "PRODUCTS",
        NO_SUBSCRIPTION: "NO_SUBSCRIPTION",
        CONTACT_US: "CONTACT_US",
        B2C_EDIT_SUBSCRIPTION: "B2C_EDIT_SUBSCRIPTION",
        B2C_SUBSCRIPTION_CONTRACT: "B2C_SUBSCRIPTION_CONTRACT",
        B2C_SUBSCRIPTION_DONE: "B2C_SUBSCRIPTION_DONE",
        B2C_SUBSCRIPTION: "B2C_SUBSCRIPTION",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        E_SIGN: "E_SIGN",
        PAYMENT: "PAYMENT",
      },
      [TEMPLATE_TYPES.B2C_SOLYON]: {
        PROFILE: "PROFILE",
        ADHERENT_BIRTHDATE: "ADHERENT.BIRTHDATE",
        INCOME: "INCOME",
        ADHERENT_INFO: "ADHERENT.INFO",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        UPSELLS: "UPSELLS",
        PROTECT_INCOME: "PROTECT_INCOME",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        ADHERENT_SOCIAL_SECURITY_NUMBER: "ADHERENT.SOCIAL.SECURITY.NUMBER",
        RELATED_PERSONS: "RELATED.PERSONS",
        ADHERENT_BANK_INFORMATION: "ADHERENT.BANK.INFORMATION",
        E_SIGN: "E_SIGN",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        RGPD: "RGPD",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
        GENERATE_E_SIGN_DOCUMENTS: "GENERATE_E_SIGN_DOCUMENTS",
      },
      [TEMPLATE_TYPES.B2C_LMF]: {
        PROFILE: "PROFILE",
        CONTACT: "CONTACT",
        CONTACT_CSS: "CONTACT_CSS",
        CONTACT_ALREADY_ADHERENT: "CONTACT_ALREADY_ADHERENT",
        COLLECTION_NEEDS: "COLLECTION_NEEDS",
        PRODUCTS: "PRODUCTS",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        THANK_YOU: "THANK_YOU",
        ADHERENT_DETAILS: "ADHERENT.DETAILS",
        MODULES: "MODULES",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADDRESS_ADHERENT: "ADDRESS_ADHERENT",
        SOCIAL_SECURITY_NUMBER: "SOCIAL_SECURITY_NUMBER",
        PAYMENT: "PAYMENT",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        SPOUSE_JUSTIFICATIONS: "SPOUSE_JUSTIFICATIONS",
        CHILDREN_JUSTIFICATIONS: "CHILDREN_JUSTIFICATIONS",
        PAYER_JUSTIFICATIONS: "PAYER_JUSTIFICATIONS",
        BENEFICIARIES: "BENEFICIARIES",
        CONTRACT: "CONTRACT",
        E_SIGN: "E_SIGN",
        BANK_CARD: "BANK_CARD",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
      },
      [TEMPLATE_TYPES.B2C_AMELLIS]: {
        PROFILE: "PROFILE",
        ADHERENT_BIRTHDATE: "ADHERENT.BIRTHDATE",
        INCOME: "INCOME",
        ADHERENT_INFO: "ADHERENT.INFO",
        NEEDS: "NEEDS",
        PRODUCTS: "PRODUCTS",
        UPSELLS: "UPSELLS",
        PROTECT_INCOME: "PROTECT_INCOME",
        EFFECTIVE_DATE: "EFFECTIVE_DATE",
        ADHERENT_TELECOMS: "ADHERENT.TELECOMS",
        ADHERENT_SOCIAL_SECURITY_NUMBER: "ADHERENT.SOCIAL.SECURITY.NUMBER",
        RELATED_PERSONS: "RELATED.PERSONS",
        ADHERENT_BANK_INFORMATION: "ADHERENT.BANK.INFORMATION",
        E_SIGN: "E_SIGN",
        JUSTIFICATIONS: "JUSTIFICATIONS",
        RGPD: "RGPD",
        SUBSCRIPTION_DONE: "SUBSCRIPTION_DONE",
        GENERATE_E_SIGN_DOCUMENTS: "GENERATE_E_SIGN_DOCUMENTS",
      },
    },
  },
};

export const CONTACT_TYPES = {
  NEW: "NEW",
  NO_ANSWER: "NO_ANSWER",
  WRONG_NUMBER: "WRONG_NUMBER",
  WON: "WON",
  DUPLICATED: "DUPLICATED",
  QUOTE_SENT: "QUOTE_SENT",
};

export const MOMENT_UNITS_IN_MINUTES = {
  ONE_HOUR: 60,
};

export const COVERAGE_CATEGORIES = {
  HOSPITALIZATION: "HOSPITALIZATION",
  MATERNITY: "MATERNITY",
  DENTAL: "DENTAL",
  MEDICAL_CARE: "MEDICAL_CARE",
  EQUIPMENT: "EQUIPMENT",
  ALTERNATIVE_MEDICINE: "ALTERNATIVE_MEDICINE",
  PREVENTION: "PREVENTION",
  OTHER: "OTHER",
  OPTICAL: "OPTICAL",
};

export const COVERAGE_NEEDS = {
  HOSPITALIZATION: "hospitalization",
  DENTAL: "dental",
  OPTICAL: "optical",
  MEDICAL_CARE: "medicalExpenses",
  ALTERNATIVE_MEDICINE: "alternativeMedicine",
  EQUIPMENT: "hearingAid",
};

export const SUPPORTING_INFORMATION_CATEGORIES = {
  BASE_REFUND: "BASE_REFUND",
  CONTEXT: "CONTEXT",
  PRACTICAL_CASES: "PRACTICAL_CASES",
  REINFORCEMENT: "REINFORCEMENT",
  DESCRIPTION: "DESCRIPTION",
  BONUS: "BONUS",
  INCLUDED: "INCLUDED",
  EXCLUDED: "EXCLUDED",
  REIMBURSEMENT: "REIMBURSEMENT",
  LIMIT: "LIMIT",
  HEADLIGHT_WARRANTY: "HEADLIGHT_WARRANTY",
};

export const DEFAUlT_PAGINATION = {
  take: 3,
  skip: 0,
};

export const CURRENCY_SYMBOL = {
  EUR: "€",
  USD: "$",
  XPF: "XPF",
  DEFAULT: "",
};

export const COVERAGE_LIMIT_CATEGORIES = {
  COST: "COST",
  COST_PER_YEAR: "COST_PER_YEAR",
  BASE_REFUND: "BASE_REFUND",
  REAL_COSTS: "REAL_COSTS",
  INTEGRAL_RBT: "INTEGRAL_RBT",
  TEXT: "TEXT",
};

export const SUBSCRIPTION_FORM_KEYS = {
  ADDITIONAL_INFORMATION: {
    ADHERENT: "ADHERENT",
    ACTIVITY: "ACTIVITY",
    CONTACT: "CONTACT",
    PARTNER: "PARTNER",
    CHILDREN: "CHILDREN",
    PAYMENT: "PAYMENT",
    REFUND: "REFUND",
    CONTRACT: "CONTRACT",
    TERMINATION_REQUEST: "TERMINATION_REQUEST",
    BROKERAGE_MANDATE: "BROKERAGE_MANDATE",
    INFORMATION: "INFORMATION",
    SPONSORSHIP_MEMBERSHIP: "SPONSORSHIP_MEMBERSHIP",
    CONSENTS: "CONSENTS",
  },
  PROOF: {
    ID: "ID",
    KBIS: "KBIS",
    PAYER: "PAYER",
    SPOUSE: "SPOUSE",
    CHILDREN: "CHILDREN",
    ADHERENT: "ADHERENT",
    PAY_SLIP: "PAY_SLIP",
    TAX_NOTICE: "TAX_NOTICE",
    BANK_ACCOUNT: "BANK_ACCOUNT",
    PROFESSIONAL_BANK_ACCOUNT: "PROFESSIONAL_BANK_ACCOUNT",
    PENSION_FUND: "PENSION_FUND",
    SOCIAL_SECURITY_CERTIFICATE: "SOCIAL_SECURITY_CERTIFICATE",
    ELECTRONIC_SIGNATURE_ELIGIBILITY: "ELECTRONIC_SIGNATURE_ELIGIBILITY",
    ENROLLMENT_CERTIFICATE: "ENROLLMENT_CERTIFICATE",
    COMMUNITY_ATTACHMENT: "COMMUNITY_ATTACHMENT",
    HEALTH_INSURANCE_RIGHTS_CERTIFICATE: "HEALTH_INSURANCE_RIGHTS_CERTIFICATE",
  },
  SIGNATURE: {
    E_SIGNATURE: "E_SIGNATURE",
    DOCUMENTS: "DOCUMENTS",
  },
};

export const ANSET_SUBSCRIPTION_FORM_KEYS = {
  ADDITIONAL_INFORMATION: {
    ADHERENT: "ADHERENT",
    CONTACT: "CONTACT",
    PAYMENT: "PAYMENT",
    TERMINAL: "TERMINAL",
    SUBSCRIBER: "SUBSCRIBER",
  },
  PROOF: {
    // PURCHASE_INVOICE: "PURCHASE_INVOICE",
    // PROOF_OF_RESIDENCE: "PROOF_OF_RESIDENCE",
    // ID: "ID",
    // BANK_ACCOUNT: "BANK_ACCOUNT",
    SUPPORTING_DOCUMENTS: "SUPPORTING_DOCUMENTS",
  },
  SIGNATURE: {
    E_SIGNATURE: "E_SIGNATURE",
    DOCUMENTS: "DOCUMENTS",
  },
};

export const GENDER = {
  MALE: "M",
  FEMALE: "F",
};

export const AUTHORITY_TYPE = {
  FATHER: "FATHER",
  MOTHER: "MOTHER",
  BOTH: "BOTH",
  SELF: "SELF",
};

export const RELATIONSHIP = {
  CHILD: "CHILD",
  SPOUSE: "SPOUSE",
};

export const BOOLEAN = {
  true: true,
  false: false,
};

export const ORGANIZATION_TYPES = {
  PROV: "PROV",
  DEPT: "DEPT",
  TEAM: "TEAM",
  GOVT: "GOVT",
  INS: "INS",
  PAY: "PAY",
  EDU: "EDU",
  RELI: "RELI",
  CRS: "CRS",
  CG: "CG",
  BUS: "BUS",
  BROKER: "BROKER",
  OTHER: "OTHER",
};

export const ORGANIZATION_FORMS = {
  PROFESSIONAL_CIVIL_COMPANY: "PROFESSIONAL_CIVIL_COMPANY",
  GIE: "GIE",
  LIMITED_PARTNERSHIP: "LIMITED_PARTNERSHIP",
  SOLE_PROPRIETORSHIP: "SOLE_PROPRIETORSHIP",
  SIMPLIFIED_JOINT_STOCK_COMPANY: "SIMPLIFIED_JOINT_STOCK_COMPANY",
  GENERAL_PARTNERSHIP: "GENERAL_PARTNERSHIP",
  EURL: "EURL",
  SELCA: "SELCA",
  SELAFA: "SELAFA",
  PUBLIC_LIMITED_COMPANY: "PUBLIC_LIMITED_COMPANY",
  SARL: "SARL",
  LIMITED_PARTNERSHIP_WITH_SHARES: "LIMITED_PARTNERSHIP_WITH_SHARES",
  PROFESSIONAL_LIBERAL_COMPANY: "PROFESSIONAL_LIBERAL_COMPANY",
  SINGLE_MEMBER_JOINT_STOCK_COMPANY: "SINGLE_MEMBER_JOINT_STOCK_COMPANY",
  SELARL: "SELARL",
  CIVIL_COMPANY_FOR_SHARED_PROFESSIONAL_SERVICES:
    "CIVIL_COMPANY_FOR_SHARED_PROFESSIONAL_SERVICES",
  SINGLE_MEMBER_LIBERAL_COMPANY: "SINGLE_MEMBER_LIBERAL_COMPANY",
  PARTNERSHIP: "PARTNERSHIP",
};

export const DATE_FORMAT = "DD/MM/YYYY";
export const API_DATE_FORMAT = "YYYY-MM-DD";
export const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm";
export const TIME_FORMAT = "HH:mm:ss";

export const RISKS = [
  "2-WHEELERS",
  "CROP_INSURANCE",
  "ALL-RISKS_CONSTRUCTION_INSURANCE",
  "SCOOTER_INSURANCE",
  "BIKE_INSURANCE",
  "LIFE_INSURANCE",
  "CAR",
  "OTHER",
  "BOATS",
  "MACHINE_BREAKDOWN",
  "CARAVANS",
  "CREDIT",
  "CYBER_RISKS",
  "DEATH",
  "TAX_DEFERRAL",
  "DEPENDENCE",
  "WORKS_DAMAGE_INSURANCE",
  "BORROWER",
  "CAR_FLEET",
  "FUNERAL_EXPENSES",
  "OVERHEADS",
  "FINANCIAL_GUARANTEE_FOR_COMPLETION",
  "HEALTH_CASH_PLAN",
  "KEY_MAN",
  "GROUP_INSURANCE_FOR_SMALL_BUSINESSES",
  "BUILDING",
  "REAL_ESTATE_INVESTMENT",
  "UNPAID_RENT / RENTAL_RISK",
  "TRANSPORTED_GOODS",
  "HR",
  "PROFESSIONAL_LIABILITY_INSURANCE",
  "ART_OBJECTS_AND_COLLECTIONS",
  "PERSONAL_PENSION_ACCOUNT",
  "EMPLOYEE_SAVINGS_PLAN",
  "INDIVIDUAL_RETIREMENT_PLAN",
  "BUSINESS_INTERRUPTION",
  "GROUP_INSURANCE_FOR_NON-PROFIT_ORGANIZATIONS",
  "GROUP_INSURANCE",
  "SELF-EMPLOYED_INSURANCE",
  "LEGAL_PROTECTION_FOR_PRIVATE_LIFE",
  "LEGAL_PROTECTION_FOR_PROFESSIONALS",
  "FRANCHISE_BUYBACK",
  "HUNTING_LIABILITY_INSURANCE",
  "DECENNIAL_LIABILITY_INSURANCE",
  "MEDICAL_LIABILITY_INSURANCE",
  "ORGANIZATION_LIABILITY_INSURANCE",
  "PROFESSIONAL_LIABILITY_INSURANCE",
  "PRIVATE_LIFE",
  "EDUCATION_ANNUITY",
  "LIFE_ANNUITY",
  "DIRECTORS'_LIABILITY",
  "RETIREMENT_PLAN_83",
  "MADELIN_RETIREMENT_PLAN",
  "HEALTH_INSURANCE_FOR_ACTIVE_PEOPLE",
  "ANIMAL_HEALTH_INSURANCE",
  "GROUP_HEALTH_INSURANCE",
  "HEALTH_INSURANCE_FOR_SENIORS",
  "HEALTH_INSURANCE_FOR_THE_SELF-EMPLOYED",
  "SCHOOL_INSURANCE",
  "TRAVEL_INSURANCE",
];

export const CLIENT_CATEGORY = {
  PARTICULAR: "PARTICULAR",
  PROFESSIONAL: "PROFESSIONAL",
  TNS: "TNS",
  TERRITORIAL_AGENT: "TERRITORIAL_AGENT",
  BUSINESS_LEADER: "BUSINESS_LEADER",
};

export const CLIENT_STATUS = {
  LEAD: "LEAD",
  OLD_CLIENT: "OLD_CLIENT",
  CLIENT: "CLIENT",
};
export const ATTACHMENT_STATUSES = {
  CRYPTED: "crypted",
  DECRYPTED: "decrypted",
};

export const INITIAL_VALUES = {
  take: 10,
  skip: 0,
};

export const MAX_FEES_VALUE = 50;

export const CONTACT_POINT_SYSTEM = {
  PHONE: "PHONE",
  LANDLINE: "LANDLINE",
  COMPLEMENT: "COMPLEMENT",
  FAX: "FAX",
  EMAIL: "EMAIL",
  ADDRESS_NUMBER: "ADDRESS_NUMBER",
  REPETITION_INDEX: "REPETITION_INDEX",
  STREET: "STREET",
  APARTMENT: "APARTMENT",
  LOCATION: "LOCATION",
  STREET_TYPE: "STREET_TYPE",
  ZIP_CODE: "ZIP_CODE",
  COUNTRY: "COUNTRY",
  CITY: "CITY",
  BIRTH_CITY: "BIRTH_CITY",
  BIRTH_COUNTRY: "BIRTH_COUNTRY",
  DEPARTMENT_OF_BIRTH: "DEPARTMENT_OF_BIRTH",
  BIRTH_ZIP_CODE: "BIRTH_ZIP_CODE",
  MAILBOX: "MAILBOX",
  POSTAL_ZIP_CODE: "POSTAL_ZIP_CODE",
  POSTAL_CITY: "POSTAL_CITY",
  ADDRESS: "ADDRESS",
  ADDRESS_LOCATION: "ADDRESS_LOCATION",
  ADDRESS_POSTAL: "ADDRESS_POSTAL",
  RESIDENCE: "RESIDENCE",
  ADHERENT_NUMBER: "ADHERENT_NUMBER",
};

export const NAVIGATION_DIRECTIONS = {
  BACK: -1,
};

export const USERS = {
  ADMIN: "ADMIN",
  REGULAR: "REGULAR",
  BENEFICIARY: "BENEFICIARY",
  ADHERENT: "ADHERENT",
  BROKER: "BROKER",
  REPRESENTATIVE: "REPRESENTATIVE",
  COMMERCIAL: "COMMERCIAL",
};

export const TRACER_TYPES = {
  MANUAL: "manual",
  COMPARISON: "comparison",
};

export const INPUT_TYPES = {
  TEXT: "text",
  SELECT: "select",
  DATE: "date",
};

export const QUALIFIER_TYPES = {
  UNTREATED: "UNTREATED",
  ARGUED: "ARGUED",
  NON_ARGUED: "NON_ARGUED",
  WRONG_NUMBER: "WRONG_NUMBER",
  DUPLICATE: "DUPLICATE",
  NO_ANSWER: "NO_ANSWER",
  REFUSAL_ANSWER: "REFUSAL_ANSWER",
  ANSWERING_MACHINE: "ANSWERING_MACHINE",
  QUOTE_SENT: "QUOTE_SENT",
  SIGNED: "SIGNED",
};

export const SOURCE_TYPES = {
  MANUAL: "manual",
};

export const SOCIAL_REGIMES = {
  SECURITE_SOCIALE: "SECURITE_SOCIALE",
  ALSACE_MOSELLE: "ALSACE_MOSELLE",
  REGIME_SPECIAL: "REGIME_SPECIAL",
  REGIME_SALARIES_AGRICOLES: "REGIME_SALARIES_AGRICOLES",
  SECURITE_SOCIALE_INDEPENDANTS: "SECURITE_SOCIALE_INDEPENDANTS",
};

export const LMF_SOCIAL_REGIMES = {
  SECURITE_SOCIALE: "SECURITE_SOCIALE",
  ALSACE_MOSELLE: "ALSACE_MOSELLE", // Local
  MINIER: "MINIER",
  REGIME_SALARIES_AGRICOLES: "REGIME_SALARIES_AGRICOLES",
  GRA_SELF_EMPLOYED: "GRA_SELF_EMPLOYED", // GRA Professions indépendantes (formerly “Travailleur Non Salarié”)
  // BORDER_WORKERS: "BORDER_WORKERS", // Régime Frontaliers
  // GRA_MINORS_AND_EQUIVALENT: "GRA_MINORS_AND_EQUIVALENT", // GRA Mineurs et assimilés (formerly “Régime Mineurs”)
};

export const PRICER_KEYS = {
  API: {
    ALPTIS: "api.alptis",
  },
  MOCK: "mock",
  DB: "db",
};

export const PRICER_TYPES = {
  ALPTIS: "api.alptis",
  MOCK: "mock",
  DB: "db",
};

export const STATUS = [
  "default",
  "green",
  "danger",
  "warning",
  "info",
  "red",
  "black",
];
export const DEFAULT_STATUS = "default";

export const TYPES = {
  DEFAULT: "default",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  DANGER: "danger",
};

export const COMPONENTS_SIZES = {
  SMALL: "small",
  LARGE: "large",
  MEDIUM: "medium",
  X_LARGE: "xLarge",
};

export const CASE_TYPES = {
  NEW_CONTRACT: "NEW_CONTRACT",
  RETURN_TO_COMPETITION: "RETURN_TO_COMPETITION",
};

export const SALE_MODES = {
  FACE_TO_FACE: "FACE_TO_FACE",
  DISTANT: "DISTANT",
};

export const PROJECT_TYPES = {
  HOT_LEAD: "HOT",
  COLD_LEAD: "COLD",
};

export const PROJECT_SOURCE = {
  CLIENT: "CLIENT",
  BROKER: "BROKER",
};

export const PROCESS_TAGS = {
  IN_PROGRESS: "IN_PROGRESS",
  CURRENT_SUBSCRIPTION: "CURRENT_SUBSCRIPTION",
  ELECTRONIC_SIGNATURE_PENDING: "ELECTRONIC_SIGNATURE_PENDING",
  SIGNED: "SIGNED",
  EXPIRED: "EXPIRED",
  QUOTE_SENT: "QUOTE_SENT",
  CLOSE: "CLOSE",
};

export const DELTA_END_TYPES = {
  ADD_PERIOD: "ADD_PERIOD",
  END_OF_YEAR: "END_OF_YEAR",
};

export const PERIOD_UNITS = {
  DAYS: "days",
  MONTHS: "months",
  YEARS: "years",
};

export const COMMISSION_TYPES = {
  LINEAR: "LINEAR",
  WITHHOLDING: "WITHHOLDING",
};

export const ACTION_TYPES = {
  NAVIGATE: "NAVIGATE",
  WEBHOOK: "WEBHOOK",
  GENERATE_DOCUMENT: "GENERATE_DOCUMENT",
  DOWNLOAD_DOCUMENTS: "DOWNLOAD_DOCUMENTS",
  SYNC_PROCESSES: "SYNC_PROCESSES",
  NO_SYNC_PROCESSES: "NO_SYNC_PROCESSES",
};

export const FAMILY_SITUATION = {
  MARRIED: "MARRIED",
  DIVORCED: "DIVORCED",
  SEPARATED: "SEPARATED",
  SINGLE: "SINGLE",
  WIDOWED: "WIDOWED",
  PACS: "PACS",
  COHABITING: "COHABITING",
};

export const FAMILY_SITUATION_LMF = {
  COUPLE_WITHOUT_CHILDREN: "COUPLE_WITHOUT_CHILDREN",
  COUPLE_WITH_CHILDREN: "COUPLE_WITH_CHILDREN",
  SINGLE_WITHOUT_CHILDREN: "SINGLE_WITHOUT_CHILDREN",
  SINGLE_WITH_CHILDREN: "SINGLE_WITH_CHILDREN",
};

export const PAYMENT_TYPES = {
  DEBIT: "DEBIT",
  DELEGATE: "DELEGATE",
  TIP: "TIP",
};

export const PAYMENT_FREQUENCIES = {
  MONTHLY: "MONTHLY",
  QUARTERLY: "QUARTERLY",
  BIANNUAL: "BIANNUAL",
  ANNUAL: "ANNUAL",
};

export const PAYMENT_RECEIVER = {
  SAME_ACCOUNT: "SAME_ACCOUNT",
  ANOTHER_ACCOUNT: "ANOTHER_ACCOUNT",
};

export const CONTACT_EXERCISE_FRAME = {
  EMPLOYEE: "EMPLOYEE",
  INDEPENDENT: "INDEPENDENT",
};

export const SOCIO_PROFESSIONAL_CATEGORIES = {
  FARMERS: "FARMERS",
  ARTISANS: "ARTISANS",
  EXECUTIVES: "EXECUTIVES",
  EXECUTIVES_AND_PUBLIC_SERVICE_EMPLOYEES:
    "EXECUTIVES AND PUBLIC SERVICE EMPLOYEES",
  ENTREPRENEURS: "ENTREPRENEURS",
  TRADERS_AND_SIMILAR: "TRADERS AND SIMILAR",
  EMPLOYEES_AND_SUPERVISORS: "EMPLOYEES AND SUPERVISORS",
  WORKERS: "WORKERS",
  PEOPLE_WITHOUT_PROFESSIONAL_ACTIVITY: "PEOPLE WITHOUT PROFESSIONAL ACTIVITY",
  LIBERAL_PROFESSIONS_AND_SIMILAR: "LIBERAL PROFESSIONS AND SIMILAR",
  RETIREES: "RETIREES",
  OTHER: "OTHER",
};

export const SITUATION_PROFESSIONAL = {
  SALARIED_PRIVATE_SECTOR: "SALARIED_PRIVATE_SECTOR",
  SALARIED_PUBLIC_SECTOR: "SALARIED_PUBLIC_SECTOR",
  SEARCHING_FOR_A_JOB: "SEARCHING_FOR_A_JOB",
  STUDENT: "STUDENT",
  INDEPENDENT: "INDEPENDENT",
  RETIRED: "RETIRED",
};

export const SITUATION_PROFESSIONAL_SALARIED_PRIVATE_SECTOR = {
  EMPLOYEE: "EMPLOYEE",
  WORKER: "WORKER",
  INTERMEDIATE_PROFESSION: "INTERMEDIATE_PROFESSION",
  EXECUTIVE: "EXECUTIVE",
};

export const SITUATION_PROFESSIONAL_SALARIED_PUBLIC_SECTOR = {
  STATE_CIVIL_SERVICE: "STATE_CIVIL_SERVICE",
  TERRITORIAL_CIVIL_SERVICE: "TERRITORIAL_CIVIL_SERVICE",
  HOSPITAL_CIVIL_SERVICE: "HOSPITAL_CIVIL_SERVICE",
};

export const SITUATION_PROFESSIONAL_SEARCHING_FOR_A_JOB = {
  WORKING_STUDENT: "WORKING_STUDENT",
  NON_WORKING_STUDENT: "NON_WORKING_STUDENT",
};

export const SITUATION_PROFESSIONAL_STUDENT = {
  WORKING_STUDENT: "WORKING_STUDENT",
  NON_WORKING_STUDENT: "NON_WORKING_STUDENT",
};

export const SITUATION_PROFESSIONAL_INDEPENDENT = {
  BUSINESS_LEADER: "BUSINESS_LEADER",
  LIBERAL_PROFESSION: "LIBERAL_PROFESSION",
  SELF_EMPLOYED: "SELF_EMPLOYED",
  FARMER: "FARMER",
};

export const SITUATION_PROFESSIONAL_RETIRED = {
  STATE_CIVIL_SERVICE_RETIRED: "STATE_CIVIL_SERVICE_RETIRED",
  TERRITORIAL_CIVIL_SERVICE_RETIRED: "TERRITORIAL_CIVIL_SERVICE_RETIRED",
  HOSPITAL_CIVIL_SERVICE_RETIRED: "HOSPITAL_CIVIL_SERVICE_RETIRED",
  OTHER_RETIRED: "OTHER_RETIRED",
};

export const REPETITION_INDEX = [
  "A",
  "B (Bis)",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T (Ter)",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

export const INSURANCE_PLAN_ATTACHMENTS_TYPES = {
  STATUSES: "STATUSES",
  IPID: "IPID",
  INFO_NOTICE: "INFO_NOTICE",
  BROCHURE: "BROCHURE",
};

export const SUBSCRIPTION_ATTACHMENTS_TYPES = {
  MEMBERSHIP_FORM: "MEMBERSHIP_FORM",
  DUTY_OF_ADVICE: "DUTY_OF_ADVICE",
  SEPA_DIRECT_DEBIT_MANDATE: "SEPA_DIRECT_DEBIT_MANDATE",
  SUPPLEMENTARY_DOCUMENTS: "SUPPLEMENTARY_DOCUMENTS",
};

export const QUOTE_ATTACHMENTS_TYPES = {
  QUOTE: "QUOTE",
  DUTY_OF_ADVICE_QUOTE: "DUTY_OF_ADVICE_QUOTE",
};

export const SUBSCRIPTION_STATUSES = {
  DRAFT: "DRAFT",
  IN_PROGRESS: "IN_PROGRESS",
  PENDING: "PENDING",
  SIGNED: "SIGNED",
};

export const LOGS_STATUSES_KEYS = {
  updateSubscription: "data.result.status",
  addQualification: "data.result.qualifier.name",
  addQuote: "data.result.status",
  sendQuote: "data.result.status",
  generateQuoteDocuments: "data.result.status",
};

export const DEBIT_POSSIBLE_DATES = [
  "5",
  "8",
  "10",
  "12",
  "15",
  "20",
  "25",
  "30",
];

export const LMF_DEBIT_POSSIBLE_DATES = ["5", "10", "20"];

export const JOB_LIST = {
  PROFESSIONAL_ACTIVITY_OTHER_SECTOR: "PROFESSIONAL_ACTIVITY_OTHER_SECTOR",
  PROFESSIONAL_ACTIVITY_PRIVATE_SECTOR: "PROFESSIONAL_ACTIVITY_PRIVATE_SECTOR",
  FARMER: "FARMER",
  ARTISAN: "ARTISAN",
  ENTREPRENEUR: "ENTREPRENEUR",
  TRADER: "TRADER",
  SEARCHING_FOR_A_JOB: "SEARCHING_FOR_A_JOB",
  INDEPENDENT_ENTREPRENEUR: "INDEPENDENT_ENTREPRENEUR",
  STUDENT: "STUDENT",
  POLITICALLY_EXPOSED_ADMINISTRATIVE_FUNCTION:
    "POLITICALLY_EXPOSED_ADMINISTRATIVE_FUNCTION",
  POLITICALLY_EXPOSED_JURISDICTIONAL_FUNCTION:
    "POLITICALLY_EXPOSED_JURISDICTIONAL_FUNCTION",
  POLITICALLY_EXPOSED_MILITARY_FUNCTION:
    "POLITICALLY_EXPOSED_MILITARY_FUNCTION",
  POLITICALLY_EXPOSED_POLITICAL_OR_DIPLOMATIC_FUNCTION:
    "POLITICALLY_EXPOSED_POLITICAL_OR_DIPLOMATIC_FUNCTION",
  STATE_CIVIL_SERVICE: "STATE_CIVIL_SERVICE",
  HOSPITAL_CIVIL_SERVICE: "HOSPITAL_CIVIL_SERVICE",
  TERRITORIAL_CIVIL_SERVICE: "TERRITORIAL_CIVIL_SERVICE",
  AGRICULTURAL_PROFESSION: "AGRICULTURAL_PROFESSION",
  LIBERAL_PROFESSION: "LIBERAL_PROFESSION",
  RETIRED: "RETIRED",
  UNEMPLOYED: "UNEMPLOYED",
  ACTIVE: "ACTIVE",
};

export const REGEX = {
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
};

export const DEPARTMENTS = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "2A",
  "2B",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "60",
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "67",
  "68",
  "69",
  "70",
  "71",
  "72",
  "73",
  "74",
  "75",
  "76",
  "77",
  "78",
  "79",
  "80",
  "81",
  "82",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "89",
  "90",
  "91",
  "92",
  "93",
  "94",
  "95",
  "96",
  "97",
];

export const CONTENT_TYPES = {
  XLSX: "application/xlsx",
  PDF: "application/pdf",
  JPEG: "image/jpeg",
  JPG: "image/jpg",
  PNG: "image/png",
};

export const MONTH_OPTIONS = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

export const ATTACHMENT_TYPES = {
  PRESCRIPTION: "PRESCRIPTION",
  BILL: "BILL",
  RESULT: "RESULT",
  VIGNETTE: "VIGNETTE",
  TREATMENT_SHEET: "TREATMENT_SHEET",
  REPORT: "REPORT",
  SUPPORT_FORM: "SUPPORT_FORM",
  HONORARY_NOTES: "HONORARY_NOTES",
  OTHER: "OTHER",
  ORGANIZATION_BACKGROUND: "organization.background",
  ORGANIZATION_FAVICON: "organization.favicon",
  PROFILE: "PROFILE",
  SIGNATURE: "SIGNATURE",
  INVOICE: "INVOICE",
  DUTY_OF_ADVICE: "DUTY_OF_ADVICE",
  PAYER_CIN: "PAYER_CIN",
  PAYER_RIB: "PAYER_RIB",
  CONTRIBUTION_PAYMENT_AGREEMENT: "CONTRIBUTION_PAYMENT_AGREEMENT",
  CIN: "CIN",
  PAYMENT_ACCOUNT: "PAYMENT_ACCOUNT",
  PROFESSIONAL_PAYMENT_ACCOUNT: "PROFESSIONAL_PAYMENT_ACCOUNT",
  STUDENT_ID_OR_ENROLLMENT_CERTIFICATE: "STUDENT_ID_OR_ENROLLMENT_CERTIFICATE",
  HEALTH_INSURANCE_RIGHTS_CERTIFICATE: "HEALTH_INSURANCE_RIGHTS_CERTIFICATE",
  REFUND_ACCOUNT: "REFUND_ACCOUNT",
  SOCIAL_SECURITY_CERTIFICATE: "SOCIAL_SECURITY_CERTIFICATE",
  MEMBERSHIP_FORM: "MEMBERSHIP_FORM",
  IPID: "IPID",
  COVERAGE_GRID: "COVERAGE_GRID",
  KBIS: "KBIS",
  INFO_NOTICE: "INFO_NOTICE",
  BROCHURE: "BROCHURE",
  COMMISSION_STATEMENT: "COMMISSION_STATEMENT",
  ICON: "ICON",
  PENSION_FUND: "PENSION_FUND",
  COMMUNITY_ATTACHMENT: "COMMUNITY_ATTACHMENT",
  PAY_SLIP: "PAY_SLIP",
  TAX_NOTICE: "TAX_NOTICE",
  BANK_ACCOUNT_DETAILS_FOR_PAYMENT: "BANK_ACCOUNT_DETAILS_FOR_PAYMENT",
  PROOF_OF_ELIGIBILITY: "PROOF_OF_ELIGIBILITY",
  CHILD_DEPENDENT_PROOF: "CHILD_DEPENDENT_PROOF",
};

export const BANK_ACCOUNT_OWNER_TYPE = {
  PARTICULAR: "PARTICULAR",
  COMPANY: "COMPANY",
};

export const REGEX_EXPS = {
  zipCode: /^(0[1-9]|[1-8][0-9]|9[0-8])[0-9]{3}$/,
  mobilePhone: /^(06|07)[0-9]{8}$/,
  phone: /^(0)[0-9]{9}$/,
  onlyTenDigits: /^\d{10}$/,
  onlyNumbers: /^[0][0-9]{9}$/,
  // internationalMobilePhone: /^\+\d{2}\d{9}$|^0\d{9}$/,
  internationalMobilePhone: /^(?:\+?\d{1,3}|00\d{1,3})?\s?\d{9}$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{12,}$/,
  imei: /^\d{15,17}$/,
  vini: /^\d{10}$/,
  phonePolynisie: /^(87|88|89)\d{6}$/,
  franceIban: /^(FR|CZ|NL)\d{2}20041010050500013[A-Z0-9]{6}$/,
  name: /^[A-Za-zÀ-ÖØ-öø-ÿ][A-Za-zÀ-ÖØ-öø-ÿ' -]{1,}[A-Za-zÀ-ÖØ-öø-ÿ]$/,
  mailbox: /^(BP|bp)\d+|\d{7}$/,
  address: /^(?=.*[A-Za-z])[A-Za-zÀ-ÖØ-öø-ÿ0-9\s',.-]{4,}$/,
};

export const BENEFICIARY_TYPES = {
  ADHERENT: "ADHERENT",
  SPOUSE: "SPOUSE",
  CHILD: "CHILD",
};

export const INCLUDED_BENEFICIARIES = {
  ALONE: "ALONE",
  WITH_SPOUSE: "WITH_SPOUSE",
  WITH_CHILDREN: "WITH_CHILDREN",
  ALL: "ALL",
};

export const DOCUMENTS_TYPES = {
  DUTY_OF_ADVICE: "DUTY_OF_ADVICE",
  DUTY_OF_ADVICE_QUOTE: "DUTY_OF_ADVICE_QUOTE",
  QUOTE: "QUOTE",
  MEMBERSHIP_FORM: "MEMBERSHIP_FORM",
  SEPA_DIRECT_DEBIT_MANDATE: "SEPA_DIRECT_DEBIT_MANDATE",
  SUPPLEMENTARY_DOCUMENTS: "SUPPLEMENTARY_DOCUMENTS",
  TERMINATION_LETTER: "TERMINATION_LETTER",
  TERMINATION_MANDATE: "TERMINATION_MANDATE",
  PROPOSAL: "PROPOSAL",
  SPECIAL_CONDITIONS: "SPECIAL_CONDITIONS",
  COLLECTION_SCHEDULE: "COLLECTION_SCHEDULE",
  DIRECT_DEBIT_AUTHORIZATION: "DIRECT_DEBIT_AUTHORIZATION",
  CIN: "CIN",
  PAYER_CIN: "PAYER_CIN",
  PAYER_RIB: "PAYER_RIB",
  CONTRIBUTION_PAYMENT_AGREEMENT: "CONTRIBUTION_PAYMENT_AGREEMENT",
  PAYMENT_ACCOUNT: "PAYMENT_ACCOUNT",
  PROFESSIONAL_PAYMENT_ACCOUNT: "PROFESSIONAL_PAYMENT_ACCOUNT",
  STUDENT_ID_OR_ENROLLMENT_CERTIFICATE: "STUDENT_ID_OR_ENROLLMENT_CERTIFICATE",
  REFUND_ACCOUNT: "REFUND_ACCOUNT",
  SOCIAL_SECURITY_CERTIFICATE: "SOCIAL_SECURITY_CERTIFICATE",
  KBIS: "KBIS",
  UNKNOWN: "UNKNOWN",
  STATIC_INSURANCE_PLAN: "STATIC_INSURANCE_PLAN",
  PENSION_FUND: "PENSION_FUND",
  COMMUNITY_ATTACHMENT: "COMMUNITY_ATTACHMENT",
  PAY_SLIP: "PAY_SLIP",
  TAX_NOTICE: "TAX_NOTICE",
  BANK_ACCOUNT_DETAILS_FOR_PAYMENT: "BANK_ACCOUNT_DETAILS_FOR_PAYMENT",
  PROOF_OF_ELIGIBILITY: "PROOF_OF_ELIGIBILITY",
  CHILD_DEPENDENT_PROOF: "CHILD_DEPENDENT_PROOF",
};

export const INSURANCE_PLAN_PARAMS_RULES = {
  MIN_AGE: "MIN_AGE",
  MAX_AGE: "MAX_AGE",
  DELTA_START: "DELTA_START",
  DELTA_END: "DELTA_END",
  DELTA_START_RIA: "DELTA_START_RIA",
  DELTA_END_RIA: "DELTA_END_RIA",
  EXERCISE_FRAME: "EXERCISE_FRAME",
  SOCIAL_REGIMES: "SOCIAL_REGIMES",
  DEPARTMENTS: "DEPARTMENTS",
  PROCESSES: "PROCESSES",
  DOCUMENTS: "DOCUMENTS",
  PROFESSION: "PROFESSION",
  PROFILES: "PROFILES",
  SUB_PROFILES: "SUB_PROFILES",
  IS_PHONE_SIM_OR_ESIM: "IS_PHONE_SIM_OR_ESIM",
  IS_PHONE_NEW_OR_GRADE_A: "IS_PHONE_NEW_OR_GRADE_A",
  IS_PHONE_PURCHASED_INTERNALLY: "IS_PHONE_PURCHASED_INTERNALLY",
  IS_PHONE_UNDER_THREE_YEARS: "IS_PHONE_UNDER_THREE_YEARS",
  IS_PHONE_FOR_PRIVATE_USE: "IS_PHONE_FOR_PRIVATE_USE",
  IS_CUSTOMER_IN_FRENCH_POLYNESIA: "IS_CUSTOMER_IN_FRENCH_POLYNESIA",
};

export const MODAL_STATES = {
  INITIAL: "INITIAL",
  PENDING: "PENDING",
  DONE: "DONE",
};

export const FRANCE_DEPARTMENTS = [
  { code: "01", name: "Ain" },
  { code: "02", name: "Aisne" },
  { code: "03", name: "Allier" },
  { code: "04", name: "Alpes-de-Haute-Provence" },
  { code: "05", name: "Hautes-Alpes" },
  { code: "06", name: "Alpes-Maritimes" },
  { code: "07", name: "Ardèche" },
  { code: "08", name: "Ardennes" },
  { code: "09", name: "Ariège" },
  { code: "10", name: "Aube" },
  { code: "11", name: "Aude" },
  { code: "12", name: "Aveyron" },
  { code: "13", name: "Bouches-du-Rhône" },
  { code: "14", name: "Calvados" },
  { code: "15", name: "Cantal" },
  { code: "16", name: "Charente" },
  { code: "17", name: "Charente-Maritime" },
  { code: "18", name: "Cher" },
  { code: "19", name: "Corrèze" },
  { code: "2A", name: "Corse-du-Sud" },
  { code: "2B", name: "Haute-Corse" },
  { code: "21", name: "Côte-d'Or" },
  { code: "22", name: "Côtes-d'Armor" },
  { code: "23", name: "Creuse" },
  { code: "24", name: "Dordogne" },
  { code: "25", name: "Doubs" },
  { code: "26", name: "Drôme" },
  { code: "27", name: "Eure" },
  { code: "28", name: "Eure-et-Loir" },
  { code: "29", name: "Finistère" },
  { code: "30", name: "Gard" },
  { code: "31", name: "Haute-Garonne" },
  { code: "32", name: "Gers" },
  { code: "33", name: "Gironde" },
  { code: "34", name: "Hérault" },
  { code: "35", name: "Ille-et-Vilaine" },
  { code: "36", name: "Indre" },
  { code: "37", name: "Indre-et-Loire" },
  { code: "38", name: "Isère" },
  { code: "39", name: "Jura" },
  { code: "40", name: "Landes" },
  { code: "41", name: "Loir-et-Cher" },
  { code: "42", name: "Loire" },
  { code: "43", name: "Haute-Loire" },
  { code: "44", name: "Loire-Atlantique" },
  { code: "45", name: "Loiret" },
  { code: "46", name: "Lot" },
  { code: "47", name: "Lot-et-Garonne" },
  { code: "48", name: "Lozère" },
  { code: "49", name: "Maine-et-Loire" },
  { code: "50", name: "Manche" },
  { code: "51", name: "Marne" },
  { code: "52", name: "Haute-Marne" },
  { code: "53", name: "Mayenne" },
  { code: "54", name: "Meurthe-et-Moselle" },
  { code: "55", name: "Meuse" },
  { code: "56", name: "Morbihan" },
  { code: "57", name: "Moselle" },
  { code: "58", name: "Nièvre" },
  { code: "59", name: "Nord" },
  { code: "60", name: "Oise" },
  { code: "61", name: "Orne" },
  { code: "62", name: "Pas-de-Calais" },
  { code: "63", name: "Puy-de-Dôme" },
  { code: "64", name: "Pyrénées-Atlantiques" },
  { code: "65", name: "Hautes-Pyrénées" },
  { code: "66", name: "Pyrénées-Orientales" },
  { code: "67", name: "Bas-Rhin" },
  { code: "68", name: "Haut-Rhin" },
  { code: "69", name: "Rhône" },
  { code: "70", name: "Haute-Saône" },
  { code: "71", name: "Saône-et-Loire" },
  { code: "72", name: "Sarthe" },
  { code: "73", name: "Savoie" },
  { code: "74", name: "Haute-Savoie" },
  { code: "75", name: "Paris" },
  { code: "76", name: "Seine-Maritime" },
  { code: "77", name: "Seine-et-Marne" },
  { code: "78", name: "Yvelines" },
  { code: "79", name: "Deux-Sèvres" },
  { code: "80", name: "Somme" },
  { code: "81", name: "Tarn" },
  { code: "82", name: "Tarn-et-Garonne" },
  { code: "83", name: "Var" },
  { code: "84", name: "Vaucluse" },
  { code: "85", name: "Vendée" },
  { code: "86", name: "Vienne" },
  { code: "87", name: "Haute-Vienne" },
  { code: "88", name: "Vosges" },
  { code: "89", name: "Yonne" },
  { code: "90", name: "Territoire de Belfort" },
  { code: "91", name: "Essonne" },
  { code: "92", name: "Hauts-de-Seine" },
  { code: "93", name: "Seine-Saint-Denis" },
  { code: "94", name: "Val-de-Marne" },
  { code: "95", name: "Val-d'Oise" },
  { code: "", name: "Autre/Etranger" },
];

export const GENERATED_DOCUMENTS_TYPES = [
  "QUOTE",
  "DUTY_OF_ADVICE_QUOTE",
  "DUTY_OF_ADVICE",
  "MEMBERSHIP_FORM",
  "SEPA_DIRECT_DEBIT_MANDATE",
  "TERMINATION_LETTER",
  "TERMINATION_MANDATE",
  "APPENDIX_MEMBERSHIP_FORM",
];

export const GENERATED_DOCUMENTS_VERSIONS = {
  QUOTE: ["DEFAULT", "COSA_TER", "MUTUELLE_AURA"],
  DUTY_OF_ADVICE: ["DEFAULT", "COSA_TER", "MUTUELLE_AURA"],
  DUTY_OF_ADVICE_QUOTE: ["DEFAULT", "COSA_TER", "MUTUELLE_AURA"],
  MEMBERSHIP_FORM: [
    "DEFAULT",
    "COSA_TER",
    "MUTUELLE_AURA",
    "BAI_LMF_SANTE_OK",
    "BAI_CONFORT_TNS",
    "BAI_IDF_MUTUELLE_SANTE_TNS",
    "BAI_LMF_TERRI_OK",
    "BIA_MDC_Standard",
    "BIA_MDC_SPE",
    "BIA_ASSOCIATION",
    "BIA_CONFORT_OK",
    "BIA_IDF_MUTUELLE_SANTE_OK",
    "BIA_LMF_SANTE_TNS_OK",
  ],
  SEPA_DIRECT_DEBIT_MANDATE: ["DEFAULT", "COSA_TER", "MUTUELLE_AURA"],
  TERMINATION_LETTER: ["DEFAULT", "COSA_TER", "MUTUELLE_AURA"],
  TERMINATION_MANDATE: ["DEFAULT", "COSA_TER", "MUTUELLE_AURA"],
  APPENDIX_MEMBERSHIP_FORM: [
    "AFFILIATION",
    "AFFILIATION_RENFORTS",
    "INDIVIDUELLE",
    "INDIVIDUELLE_RENFORTS",
  ],
  undefined: [],
};

export const TRACER_FILTER = {
  AURA: "Mutuelle Aura",
  COSAE_TER: "Cosae Ter",
};

export const THEMES_PALETTE = {
  [TEMPLATE_TYPES.DEFAULT]: {
    COLOR: "#0E93E5",
    BACKGROUND: "#DDF2FE",
    NAME: "Aura",
    PROSPECT_PROCESS: TEMPLATE_TYPES.RADIANCE,
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.B2B_RADIANCE_COSA]: {
    COLOR: "#BD0027",
    BACKGROUND: "#FFE1E7",
    NAME: "Cosae Ter",
    PROSPECT_PROCESS: TEMPLATE_TYPES.RADIANCE_COSA,
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.B2B_SMART_PHONE]: {
    COLOR: "#BD0027",
    BACKGROUND: "#FFE1E7",
    // NAME: "Smart Phone",
    PROSPECT_PROCESS: "",
    TITLE: "Espace Conseiller",
  },
  [TEMPLATE_TYPES.RADIANCE]: {
    COLOR: "#0E93E5",
    BACKGROUND: "#DDF2FE",
    NAME: "Aura",
    PROSPECT_PROCESS: TEMPLATE_TYPES.RADIANCE,
    TITLE: "Devis Mutuelle Régionale",
  },
  [TEMPLATE_TYPES.RADIANCE_COSA]: {
    COLOR: "#BD0027",
    BACKGROUND: "#FFE1E7",
    NAME: "Cosae Ter",
    PROSPECT_PROCESS: TEMPLATE_TYPES.RADIANCE_COSA,
    TITLE: "Devis Cosae Ter",
  },
  [TEMPLATE_TYPES.B2B_SOLYON]: {
    // NAME: "So'Lyon",
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_SOLYON,
    TITLE: "Devis So'Lyon",
  },
  [TEMPLATE_TYPES.B2C_SOLYON]: {
    // NAME: "So'Lyon",
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_SOLYON,
    TITLE: "Devis So'Lyon",
  },
  [TEMPLATE_TYPES.B2B_AMELLIS]: {
    // NAME: "Amellis",
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_AMELLIS,
    TITLE: "Devis Amellis",
  },
  [TEMPLATE_TYPES.B2B_LMF]: {
    // NAME: "LMF",
    PROSPECT_PROCESS: TEMPLATE_TYPES.B2C_LMF,
    TITLE: "Devis LMF",
  },
};

export const STATUS_USERS = {
  AVAILABLE: "AVAILABLE",
  NOT_RESPONDING: "NOT_RESPONDING",
  AWAY: "AWAY",
  BUSY: "BUSY",
};

export const STATUS_PUBLICATION = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const INSURANCE_PLAN_RISKS = {
  HEALTH: "health",
  TERMINAL: "terminal",
};

export const SUBSCRIPTION_TEMPLATES = {
  SMART_PHONE: "SmartPhone",
  HEALTH: "Health",
  SOLYON_HEALTH: "SoLyonHealth",
  LMF_HEALTH: "LmfHealth",
  AMELLIS_HEALTH: "AmellisHealth",
};

export const DEVICES_API =
  "https://script.google.com/macros/s/AKfycbxNu27V2Y2LuKUIQMK8lX1y0joB6YmG6hUwB1fNeVbgzEh22TcDGrOak03Fk3uBHmz-/exec?route=device-list";

export const ACTIVITY_TIME_OPTIONS = [50, 60, 70, 75, 80, 90, 100];

export const INCOME_TYPES = {
  MONTHLY: "MONTHLY",
  ANNUAL: "ANNUAL",
};

export const INPUT_TYPES_FULL = {
  TEXT: "text",
  EMAIL: "email",
  PASSWORD: "password",
  PHONE: "phone",
  NUMBER: "number",
  TEXTAREA: "textarea",
  CHECKBOX: "checkbox",
  SWITCH: "switch",
  COLOR: {
    SIMPLE: "color-simple",
    PICKER: "color-picker",
  },
  DATE: {
    RANGE: "date-range",
    SIMPLE: "date-simple",
  },
  RADIO: {
    SIMPLE: "radio-simple",
    GROUP: "radio-group",
  },
  SELECT: {
    NORMAL: "simple",
    // ASYNC: "async",
    // TAG: "tag",
    // SUBTEXT: "subtext",
  },
  // FILE: {
  //   SINGLE: "single-file",
  //   MULTIPLE: "multiple-file",
  // },

  // SLIDER: {
  //   SINGLE: "slider-single",
  //   RANGE: "slider-range",
  // },
  // AUTOCOMPLETE: {
  //   NORMAL: "autocomplete-normal",
  //   ASYNC: "autocomplete-async",
  // },
};

export const SKILL_TYPES = {
  ZIPCODE: "zipCode",
  ESTABLISHMENT: "establishment",
  AGENCY: "agency",
  STORE: "store",
};

export const MEMBERSHIP_ORIGINS = {
  DISPLAY: "Affichage",
  PRESS_ARTICLE: "Article dans la presse",
  WORD_OF_MOUTH: "Bouche à oreille",
  ALREADY_MEMBER: "Déjà adhérent",
  HOSPITALS: "Hôpitaux",
  ONLINE_ADVERTISING: "Publicité sur internet",
  RADIO: "Radio",
  INTERNET_SEARCH: "Recherche sur internet",
  SOCIAL_NETWORKS: "Réseaux sociaux",
  PARTNER: "Via un de nos partenaires",
  OTHER: "Autre",
};

export const ESTABLISHMENTS = [
  "Blanchisserie centrale (HCL)",
  "Centre de soins dentaire (HCL)",
  "CH Lyon Sud (HCL)",
  "Direction des affaires domaniales (HCL)",
  "Direction du personnel et des affaires sociales (HCL)",
  "Hôpital Louis Pradel (HCL)",
  "Hôpital de la Croix Rousse (HCL)",
  "Hôpital des Charpennes (HCL)",
  "Hôpital Edouard Herriot (HCL)",
  "Hôpital Femme Mère Enfant (HCL)",
  "Hôpital Geriatrique Dugoujon (HCL)",
  "Hôpital Geriatrique Pierre Garraud (HCL)",
  "Hôpital Henry Gabrielle (HCL)",
  "Hôpital neurologique Pierre Wertheimer (HCL)",
  "Hôpital Renée Sabran (HCL)",
  "Institut d'Hematologie et Oncologie Pédiatrique (HCL)",
  "Siège Administratif (HCL)",
  "Stérilisation (HCL)",
  "UCPA cuisine centrale (HCL)",
  "CH Gériatrique du Mont d'Or",
  "CH Le Vinatier",
  "CH Lucien Hussel",
  "CH Luzy-Dufeillant",
  "CH Montgelas",
  "CH Saint Cyr au Mont d'Or",
  "CH Tarare",
  "CH Villefranche",
  "Hôpital de Beaujeu",
  "Hôpital de Belleville",
  "Hôpital de Condrieu",
  "Hôpital de Pelussin",
  "Hôpital de Sainte-Foy-Lès-Lyon",
  "Hôpital Gériatrique du Val d'Azergues",
  "Hôpital Montpensier",
  "Hôpital Rural de Neuville sur Saône",
  "Autres établissements",
];

export const ATTRIBUTION_TYPE = {
  ROUND_ROBIN: "ROUND_ROBIN",
  FIRST_PICK: "FIRST_PICK",
};

export const PROCESS_CONFIG_TYPES = {
  EMAIL: "EMAIL",
  ATTRIBUTION_TYPE: "ATTRIBUTION_TYPE",
};
export const SUBSCRIBER_TYPES = {
  ADHERENT: "ADHERENT",
  OTHER: "OTHER",
};

export const BIRTH_COUNTRY_PARAMS = {
  FRANCE: "FRANCE",
  POLYNESIE_FRANCAISE: "POLYNESIE_FRANCAISE",
  OTHER: "OTHER",
};

export const ACTIVITY_STATUS = {
  ACTIVE: "En activité",
  SELF_EMPLOYED: "Libéral",
  STUDENT: "Étudiant",
  NON_SALARIED: "Travailleur Non Salarié",
  INACTIVE: "Sans activité",
};

export const QUALIFIER_TAGS = {
  CALL_LATER: "CALL_LATER",
  PURSUIT_RADIANCE: "PURSUIT_RADIANCE",
  OLD_CONTRACT: "OLD_CONTRACT",
  NO_TERMINATION: "NO_TERMINATION",
};

export const GTM_CLIENTS = {
  SOLYON: {
    GTM_ID: "AW-834510339",
    CONTACT_INFO_SUBMISSION: "AW-834510339/SqIaCNPs2agYEIO89o0D",
    CONVERSION_SUBMISSION: "AW-834510339/azTqCJSW5agYEIO89o0D",
  },
};

export const LMF_ASSOCIATION_MEMBER_TYPE = {
  FRS_FEDERATION: "FRS_FEDERATION",
  CFDT_UNION_BAS_RHIN: "CFDT_UNION_BAS_RHIN",
  LSR_FEDERATION: "LSR_FEDERATION",
  MCCORMICK_ALUMNI_ASSOCIATION: "MCCORMICK_ALUMNI_ASSOCIATION",
  EPRO_SOLIDAIRES_EURODIF_RETIREES: "EPRO_SOLIDAIRES_EURODIF_RETIREES",
  CGT_RETIRED_CHAFFOTEAUX_MAURY: "CGT_RETIRED_CHAFFOTEAUX_MAURY",
  CFDT_UNION_HAUT_RHIN: "CFDT_UNION_HAUT_RHIN",
  ORANOR_AREVA_RETIREES: "ORANOR_AREVA_RETIREES",
  CGT_RETIREES: "CGT_RETIREES",
  RETIREMENT_SPORTS: "RETIREMENT_SPORTS",
  RETIREMENT_SOLIDARITY_LEISURE: "RETIREMENT_SOLIDARITY_LEISURE",
};

export const LMF_ORIGINS = {
  MARKETING_CAMPAIGN: "Marketing Campaign",
  COMMUNICATION_CAMPAIGN: "Communication Campaign",
  WEB_ESTIMATOR: "Web Estimator",
  LANDING_PAGE_CONVERSION: "Landing Page Conversion %",
  REFERRAL: "Referral",
};

export const LMF_CONTACT_CANAL = {
  AGENCY: "Agency",
  OUTREACH_OFFICE: "Outreach Office",
  INCOMING_CALL: "Incoming Call",
  OUTGOING_CALL: "Outgoing Call",
  EMAIL: "Email",
  POSTAL_MAIL: "Postal Mail",
};

export const COMMUNICATION_CAMPAIGN_MEDIA = {
  TV: "Television",
  BILLBOARD: "Billboard",
  RADIO: "Radio",
  PRESS: "Press",
};

export const PROFILE_LIST = {
  RETIRED: "RETIRED",
  STUDENT: "STUDENT",
  UNEMPLOYED: "UNEMPLOYED",
  TEMPORARY_WORKER: "TEMPORARY_WORKER",
  EMPLOYEE: "EMPLOYEE",
  CROSS_BORDER_WORKER: "CROSS_BORDER_WORKER",
  TNS: "TNS",
  LIBERAL_PROFESSION: "LIBERAL_PROFESSION",
  MICRO_ENTERPRISE: "MICRO_ENTERPRISE",
  TERRITORIAL_AGENT: "TERRITORIAL_AGENT",
  RETIRED_TERRITORIAL_AGENT: "RETIRED_TERRITORIAL_AGENT",
  MUNICIPALITY: "MUNICIPALITY",
  PARTICULAR: "PARTICULAR",
  BUSINESS_LEADER: "BUSINESS_LEADER",
  THIS_FAMILY: "THIS_FAMILY",
  C2SP: "C2SP",
  C2S_EXIT_CONTRACT: "C2S_EXIT_CONTRACT",
  ASSOCIATION_MEMBER: "ASSOCIATION_MEMBER",
};

export const SUPPORTING_DOCUMENTS = {
  ID: "ID",
  KBIS: "KBIS",
  PAY_SLIP: "PAY_SLIP",
  TAX_NOTICE: "TAX_NOTICE",
  RIB_SERVICE: "RIB_SERVICE",
  ELIGIBILITY: "ELIGIBILITY",
  PENSION_FUND: "PENSION_FUND",
  PAYMENT_ACCOUNT: "PAYMENT_ACCOUNT",
  COMMUNITY_ATTACHMENT: "COMMUNITY_ATTACHMENT",
  CHILD_DEPENDENT_PROOF: "CHILD_DEPENDENT_PROOF",
  SOCIAL_SECURITY_CERTIFICATE: "SOCIAL_SECURITY_CERTIFICATE",
  HEALTH_INSURANCE_RIGHTS_CERTIFICATE: "HEALTH_INSURANCE_RIGHTS_CERTIFICATE",
  CONTRIBUTION_PAYMENT_AGREEMENT: "CONTRIBUTION_PAYMENT_AGREEMENT",
  PROFESSIONAL_PAYMENT_ACCOUNT: "PROFESSIONAL_PAYMENT_ACCOUNT",
  STUDENT_ID_OR_ENROLLMENT_CERTIFICATE: "STUDENT_ID_OR_ENROLLMENT_CERTIFICATE",
};

export const EVENT_TYPES = {
  NOTIFICATION: "NOTIFICATION",
  REMINDER: "REMINDER",
};

export const PAYMENT_STATUS = {
  PENDING: "PENDING",
  PAID: "PAID",
  FAILED: "FAILED",
};
